export default __webpack_public_path__ + "static/media/Play2.29615c48.png";